import { createFileRoute } from "@tanstack/react-router";
import { TicketReport } from "@/features/tickets/TicketReport";

export const Route = createFileRoute("/_authenticated/reports/asset-ticket-history")({
  component: () => (
    <TicketReport
      id="R-52"
      title="Asset-wise Ticket History"
      description="Full ticket history for one or more assets. Enter an asset ID to filter."
      enabledFilters={["branch", "asset", "status", "priority", "dateRange"]}
      filename="asset-ticket-history"
    />
  ),
});
